<template>
  <div
    class="items"
    :class="{
      reverse: isReversedLayout,
    }"
  >
    <!-- タブレットアイテム裏 -->
    <div
      v-if="!isMindAlte"
      class="item"
      :class="{ 'item--light': isBackColorBlack }"
    >
      <slot name="item-back" />
    </div>

    <!-- タブレットアイテム表 -->
    <div
      class="item"
      :class="[computedExtendClass, { 'item--light': isFrontColorBlack }]"
    >
      <slot name="item-front" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
  },
  props: {
    isMindAlte: Boolean,
    backColor: {
      type: Object,
      default: () => ({}),
    },
    frontColor: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      isReversedLayout: "config/getIsReversedLayout",
    }),

    isFrontColorBlack () {
      return this.frontColor && this.frontColor.name === "黒色";
    },

    isBackColorBlack () {
      return this.backColor && this.backColor.name === "黒色";
    },

    computedExtendClass () {
      const { isMindAlte } = this;
      const extendClass = [];

      if (isMindAlte) {
        extendClass.push("mind-alte");
      }

      return extendClass;
    },
  },
  watch: {},
  destroyed () {},
  methods: {
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.items .yellow .Character {
  filter: invert(15%) sepia(95%) saturate(500%) hue-rotate(358deg) brightness(95%) contrast(112%);
}
.items .red .Character {
  filter: invert(72%) sepia(26%) saturate(6428%) hue-rotate(1deg) brightness(105%) contrast(102%);
}
</style>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.items {
  display: flex;
  flex-direction: row;
  flex-grow: 1;

  &.reverse {
    flex-direction: row-reverse;
  }

  .item {
    height: 400px;
    width: 150px;
    margin: auto;
    background: black;

    // 文字色に黒が選択された場合は背景を白にし、外枠を視認できるようボーダーを付ける
    &--light {
      background: white;
      border: 1px solid black;
    }

    &.mind-alte {
      width: 300px;
    }
  }
}

// @media (min-width: 769px) {
//   #saveOrder .item {
//     width: 150px !important;
//     height: 365px !important;
//   }
// }

// @media (max-width: 768px) {
//   #saveOrder .item {
//     width: 119.83px !important;
//     height: 400px !important;
//   }
// }
</style>
